import {PermissionsMap} from '@/stores/auth/constants/permissions-map'
import {ROUTES} from './routes'

export const routesPermissionMap = {
    [ROUTES.home]: [PermissionsMap.overview.read],
    [ROUTES.onboarding.base]: [],
    [ROUTES.paymentLinks]: [PermissionsMap.payment_links.read, PermissionsMap.payment_links.full],
    [ROUTES.onlinePayments]: [
        PermissionsMap.online_payments.read,
        PermissionsMap.online_payments.full
    ],
    [ROUTES.chargebacks]: [PermissionsMap.chargebacks.read],
    [ROUTES.posPayments]: [PermissionsMap.pos_payments.read, PermissionsMap.pos_payments.full],
    [ROUTES.posAmexPayments]: [
        PermissionsMap.pos_amex_payments.read,
        PermissionsMap.pos_amex_payments.full
    ],
    [ROUTES.settlements.perSettlementDate]: [
        PermissionsMap.settlements.read,
        PermissionsMap.settlements.full
    ],
    [ROUTES.settlements.perTransactionDate]: [
        PermissionsMap.settlements.read,
        PermissionsMap.settlements.full
    ],
    [ROUTES.dcc]: [PermissionsMap.dcc.read],
    [ROUTES.zashEpos]: [PermissionsMap.zash_epos.full],
    [ROUTES.digitalReceipts]: [PermissionsMap.digital_receipts.full],
    [ROUTES.virtualTerminal]: [PermissionsMap.virtual_terminal.full],
    [ROUTES.reports]: [PermissionsMap.reports.read],
    [ROUTES.exports]: [
        PermissionsMap.pos_payments.read,
        PermissionsMap.pos_payments.full,
        PermissionsMap.pos_amex_payments.read,
        PermissionsMap.pos_amex_payments.full,
        PermissionsMap.online_payments.read,
        PermissionsMap.online_payments.full,
        PermissionsMap.settlements.full
    ],
    [ROUTES.profile]: [],
    [ROUTES.settings.developers]: [],
    [ROUTES.settings.checkout]: [],
    [ROUTES.settings.tariffs]: [],
    [ROUTES.settings.companyProfile]: [
        PermissionsMap.merchant.profile.read,
        PermissionsMap.merchant.profile.full
    ],
    [ROUTES.settings.bankAccounts]: [
        PermissionsMap.merchant.bank_accounts.read,
        PermissionsMap.merchant.bank_accounts.full
    ],
    [ROUTES.settings.base]: [
        PermissionsMap.merchant.profile.read,
        PermissionsMap.merchant.profile.full,
        PermissionsMap.merchant.bank_accounts.read,
        PermissionsMap.merchant.bank_accounts.full,
        PermissionsMap.merchant.ecom_stores.read,
        PermissionsMap.merchant.ecom_stores.full,
        PermissionsMap.merchant.pos_stores.read,
        PermissionsMap.merchant.pos_stores.full,
        PermissionsMap.teammates.read,
        PermissionsMap.teammates.full,
        PermissionsMap.payment_methods.read,
        PermissionsMap.payment_methods.full
    ],
    [ROUTES.settings.teamManagement]: [
        PermissionsMap.teammates.read,
        PermissionsMap.teammates.full
    ],
    [ROUTES.businessAccount.accountInfo]: [
        PermissionsMap.accountInfo.read,
        PermissionsMap.accountInfo.full
    ],
    [ROUTES.businessAccount.cardsManagement]: [
        PermissionsMap.cardsManagement.read,
        PermissionsMap.cardsManagement.full
    ],
    [ROUTES.settings.paymentMethods]: [
        PermissionsMap.payment_methods.read,
        PermissionsMap.payment_methods.full
    ],
    [ROUTES.settings.paymentMethodDetails]: [
        PermissionsMap.payment_methods.read,
        PermissionsMap.payment_methods.full
    ],
    [ROUTES.billing.invoices]: [PermissionsMap.invoices.read, PermissionsMap.invoices.full],
    [ROUTES.noPermissions]: []
}
